import { render, staticRenderFns } from "./channelAccountMonitor.vue?vue&type=template&id=14041c48&scoped=true"
import script from "./channelAccountMonitor.vue?vue&type=script&lang=js"
export * from "./channelAccountMonitor.vue?vue&type=script&lang=js"
import style0 from "./channelAccountMonitor.vue?vue&type=style&index=0&id=14041c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14041c48",
  null
  
)

export default component.exports